import axios from 'axios'
import ResourceConstants from '../constants/ResourceConstants'

const customerGateway = axios.create({
    baseURL: ResourceConstants.CUSTOMER_API,
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json; charset=utf-8',
    },
  })

export const resendInvite = (token, orgId, email) => {
    return customerGateway.post(`/organizations/${orgId}/users/reinvite/relay?relayToken=${token}`, { email })
}

export const copyReinviteLink = (token, orgId, email) => {
    return customerGateway.post(`/organizations/${orgId}/users/reinvite_link/relay?relayToken=${token}`, { email })
}



// WEBPACK FOOTER //
// ./src/api/invite.js